import { render, staticRenderFns } from "./ModalCookies.vue?vue&type=template&id=14d0f72e&scoped=true"
import script from "./ModalCookies.vue?vue&type=script&lang=js"
export * from "./ModalCookies.vue?vue&type=script&lang=js"
import style0 from "./ModalCookies.vue?vue&type=style&index=0&id=14d0f72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d0f72e",
  null
  
)

export default component.exports